import { WorkerPool } from "types/generated";

import { CreateWorkerPoolFields } from "./types";

// Drift detection run limit constants
export const UNLIMITED_DRIFT_DETECTION_RUNS = -1;

export const setFormDefaultValues = (workerPool?: WorkerPool): CreateWorkerPoolFields => ({
  name: workerPool?.name || "",
  certificateFile: null,
  description: workerPool?.description || "",
  space: workerPool?.spaceDetails.id || "",
  driftDetectionRunLimit: workerPool?.driftDetectionRunLimit ?? UNLIMITED_DRIFT_DETECTION_RUNS,
  labels: workerPool?.labels.map((value) => ({ value })) || [],
});
